import User from "./modules/user";
import { createStore } from "vuex";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user: User,
  },
});
